import React, { useState, useEffect } from "react";
import { WEDDING } from "../utils/config";

// Original nav — unchanged
const links = [
  ["#story", "Story"],
  ["#message", "Message"],
  ["#events", "Dates"],
  ["#gallery", "Gallery"],
  ["#map", "Venue"],
  ["#rsvp", "RSVP"],
  ["#gifts", "Gifts"],
  ["#faq", "FAQ"],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 500,
        background: scrolled ? "rgba(253,251,247,.94)" : "transparent",
        backdropFilter: scrolled ? "blur(20px)" : "none",
        borderBottom: scrolled ? "0.5px solid var(--sage-p)" : "none",
        padding: "0 36px",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        transition: "all .35s ease",
      }}
    >
      <div
        style={{
          fontFamily: "var(--font-serif)",
          fontSize: "22px",
          fontStyle: "italic",
          color: scrolled ? "var(--forest)" : "#fff",
          letterSpacing: ".06em",
          textShadow: scrolled ? "none" : "0 2px 8px rgba(0,0,0,.2)",
          transition: "color .3s",
        }}
      >
        {WEDDING.initials}
      </div>

      {/* Desktop */}
      <ul
        style={{ display: "flex", gap: "20px", listStyle: "none" }}
        className="hide-mobile"
      >
        {links.map(([href, label]) => (
          <li key={href}>
            <a
              href={href}
              className="nav-link"
              style={{
                fontSize: "9px",
                letterSpacing: ".18em",
                textTransform: "uppercase",
                color: scrolled ? "var(--muted)" : "rgba(255,255,255,.85)",
                textDecoration: "none",
                transition: "color .2s",
              }}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>

      {/* Mobile hamburger */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          fontSize: "20px",
          color: scrolled ? "var(--forest)" : "#fff",
        }}
        aria-label="Menu"
      >
        {open ? "✕" : "☰"}
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "60px",
            left: 0,
            right: 0,
            background: "rgba(253,251,247,.97)",
            backdropFilter: "blur(20px)",
            borderBottom: "0.5px solid var(--sage-p)",
            padding: "20px 36px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
          }}
        >
          {links.map(([href, label]) => (
            <a
              key={href}
              href={href}
              onClick={() => setOpen(false)}
              style={{
                fontSize: "12px",
                letterSpacing: ".18em",
                textTransform: "uppercase",
                color: "var(--muted)",
                textDecoration: "none",
              }}
            >
              {label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
